import { Router } from '@angular/router';
import { Component, OnInit, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { LoginService } from 'src/app/_services/login.service';
import { CustomValidator } from 'src/app/_services/customValidator';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  ProfileDetails: any;
  changepassword_form: UntypedFormGroup;
  show1:boolean = false;
  show:boolean = false;
  show2:boolean = false;

  incorrectoldpw: boolean = false;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @ViewChild('successModal') successModal: TemplateRef<any>;
  showpassword: boolean = false;
  constructor(public modalService: NgbModal, private fb: UntypedFormBuilder,
    private _localstorageservice: LocalStorageService, private _loginservice: LoginService , private router : Router) { }

  ngOnInit() {

    this.changepassword_form = this.fb.group({
      old_pwd: ['', Validators.required],
      new_pwd: ['',Validators.compose([
         // 1. Password Field is Required
         Validators.required,
         // 2. check whether the entered password has a number
         CustomValidator.patternValidator(/\d/, { hasNumber: true }),
         // 3. check whether the entered password has upper case letter
         CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
         // 4. check whether the entered password has a lower-case letter
         CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
         // 5. check whether the entered password has a special character
         CustomValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
         // 6. Has a minimum length of 8 characters
         Validators.minLength(8),
         // 6b. Has a maximum length of 48 characters
         Validators.maxLength(48),
         // 7. check whether the entered password has a reserved keyword
         CustomValidator.keywordIncludes("password", { hasKeyword: true })])],

      confirm_pwd: ['', Validators.required],
    })

    this.changepassword_form.get('new_pwd').valueChanges.subscribe(res=>{
      if(res != null && res != ''){
        this.showpassword = true;
        if(this.changepassword_form.value.confirm_pwd != null && this.changepassword_form.value.confirm_pwd != '') {
          if (res == this.changepassword_form.value.confirm_pwd) {
            return this.changepassword_form['controls'].confirm_pwd.setErrors(null)
          } else {
            return this.changepassword_form['controls'].confirm_pwd.setErrors({ 'invalidpwd': true })
          }
        }
      }
    })
  }


  reconfirmpwd() {
    if (this.changepassword_form.value.new_pwd == this.changepassword_form.value.confirm_pwd) {
      return this.changepassword_form['controls'].confirm_pwd.setErrors(null);
    } else {
      return this.changepassword_form['controls'].confirm_pwd.setErrors({ 'invalidpwd': true })
    }
  }

  checkpassword(){

    if (this.changepassword_form.value.old_pwd == this.changepassword_form.value.new_pwd) {
      return this.changepassword_form['controls'].new_pwd.setErrors({ 'pwdmatch': true })
    } else {
      return this.changepassword_form['controls'].new_pwd.setErrors(null)
    }

  }

  changePassword() {
    if (this.changepassword_form.valid) {

      let data =
      {
        "oldpassword": this.changepassword_form.value.old_pwd,
        "newpassword": this.changepassword_form.value.new_pwd
      }
      this._loginservice.changeuserPassword(data).subscribe((res: any) => {
        if (res.status == "success") {
          this.modalService.dismissAll();
          // this.passEntry.emit('success')
          const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        }
        else if (res.status == 'failure' && res.message == 'Incorrect old password') {
          this.incorrectoldpw = true
        }
        else {
          this.modalService.dismissAll();
          this.passEntry.emit('error')

        }
      })
    }
    else {
      this.validateAllFormFields(this.changepassword_form);
    }



  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });

  }
  modaldismiss(){
    this.modalService.dismissAll()
    let chromeid = localStorage.getItem('extensionID');
    localStorage.clear()
    localStorage.setItem('extensionID', chromeid)
    this.router.navigateByUrl('/login')
  }

  showpassworderror() {
    this.showpassword = true
  }

  focusOut() {
    this.showpassword = false
    if(this.changepassword_form.value.confirm_pwd != null && this.changepassword_form.value.confirm_pwd != '') {
      if (this.changepassword_form.value.new_pwd == this.changepassword_form.value.confirm_pwd) {
        return this.changepassword_form['controls'].new_pwd.setErrors(null)
      } else {
        return this.changepassword_form['controls'].new_pwd.setErrors({ 'invalidnewpwd': true })
      }
    }
  }
}
